import {
    FaEdit,
    FaTrash,
    FaKey,
    FaToggleOn,
    FaToggleOff,
    FaExchangeAlt
} from "react-icons/fa";
import { formatDistanceToNow } from "date-fns";
const EmployeeGrid = ({
    employees,
    onEditClick,
    onDeleteClick,
    onChangePasswordClick,
    onToggleAccess,
    loading,
    userRole,
    onReplaceClick,
}) => {

    return (
        <div className="table-container">

            <table className="records-table">

                <thead>
                    <tr>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Branch</th>
                        <th>Department</th>
                        <th>Contact No</th>
                        <th>Last Login</th>
                        <th>Action</th>
                        <th>Status</th>
                    </tr>
                </thead>

                <tbody>

                    {employees.length === 0 ? (

                        <tr>
                            <td colSpan="8" className="no-data">
                                No Employees Found
                            </td>
                        </tr>

                    ) : (

                        employees.map((employee, index) => (

                            <tr key={employee.emp_id}>


                                <td className="employee-name">
                                    {employee.emp_name}
                                </td>

                                <td>
                                    <span className="role-badge">
                                        {employee.role}
                                    </span>
                                </td>

                                <td>
                                    {Array.isArray(employee.branch)
                                        ? employee.branch.join(", ")
                                        : employee.branch}
                                </td>

                                <td>
                                    {employee.Department || "-"}
                                </td>

                                <td>
                                    {employee.contact_num}
                                </td>

                                <td>
                                    {employee.lastLogin
                                        ? formatDistanceToNow(
                                            new Date(employee.lastLogin),
                                            { addSuffix: true }
                                        )
                                        : "Never Logged in"}
                                </td>
                                <td>

                                    <div className="action-buttons">

                                        <button
                                            className="icon-btn edit-btn"
                                            onClick={() => onEditClick(employee)}
                                            title="Edit Employee"
                                        >
                                            <FaEdit />
                                        </button>

                                        {userRole === "Super-Admin" && (
                                            <button
                                                className="icon-btn delete-btn"
                                                onClick={() => onDeleteClick(employee)}
                                                title="Delete Employee"
                                            >
                                                <FaTrash />
                                            </button>
                                        )}
                                        <button
                                            className="icon-btn replace-btn"
                                            onClick={() =>
                                                onReplaceClick(employee)
                                            }
                                            title="Replace Employee Mapping"
                                        >
                                            <FaExchangeAlt />
                                        </button>

                                    </div>

                                </td>
                                <td>

                                    <button
                                        className={`toggle-access-btn ${employee.has_access
                                            ? "toggle-on"
                                            : "toggle-off"
                                            }`}
                                        onClick={() => onToggleAccess(employee)}
                                        title={
                                            employee.has_access
                                                ? "Deactivate Employee"
                                                : "Activate Employee"
                                        }
                                    >
                                        {employee.has_access ? (
                                            <FaToggleOn />
                                        ) : (
                                            <FaToggleOff />
                                        )}
                                    </button>

                                </td>

                            </tr>

                        ))

                    )}

                </tbody>
            </table>

            {loading && (
                <div className="loading-overlay">
                    Loading...
                </div>
            )}

        </div>
    );
};

export default EmployeeGrid;